import { AuthorizationStatus } from "../../utils/enums/AuthorizationStatus";
import { createAction } from "@reduxjs/toolkit";
import { ActionRouter } from "../ActionRouter/ActionRouter";

export const requireAuthorization = createAction<AuthorizationStatus>(
  ActionRouter.RequireAuthorization
);
export const setError = createAction<string | null>(ActionRouter.SetError);
